import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { fbLogin, loadFacebook } from "@/lib/facebook";

export default function useFacebookLogin(onSignedIn) {
  const [facebook, setFacebook] = useState({ enabled: false, app_id: "", version: "v18.0", busy: false });
  useEffect(() => {
    api.get("/auth/facebook/config").then((r) => setFacebook((c) => ({ ...c, ...r.data }))).catch(() => setFacebook((c) => ({ ...c, enabled: false })));
  }, []);
  const signIn = async () => {
    if (!facebook.enabled) return;
    setFacebook((c) => ({ ...c, busy: true }));
    try {
      if (!(await loadFacebook(facebook.app_id, facebook.version))) { toast.error("Couldn't load Facebook. Please try again."); return; }
      const response = await fbLogin();
      const token = response?.authResponse?.accessToken;
      if (response?.status !== "connected" || !token) { toast.message("Facebook sign-in was cancelled."); return; }
      const { data } = await api.post("/auth/facebook", { access_token: token });
      onSignedIn(data.user);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setFacebook((c) => ({ ...c, busy: false }));
    }
  };
  return { facebook, signIn };
}
